/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CarePartnerCreateDTO } from '../models/CarePartnerCreateDTO'
import type { CarePartnerDetailsDTO } from '../models/CarePartnerDetailsDTO'
import type { CarePartnerPublicResponseDTO } from '../models/CarePartnerPublicResponseDTO'
import type { CarePartnerResponseDTO } from '../models/CarePartnerResponseDTO'
import type { CarePartnerUpdateDTO } from '../models/CarePartnerUpdateDTO'
import type { PaginatedDTO_CarePartnerResponseDTO_ } from '../models/PaginatedDTO_CarePartnerResponseDTO_'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class CarePartnersService {
    /**
     * List Care Partners
     * Get a paginated list of care partners.
     * Supports filtering, sorting, and searching across multiple fields.
     * @returns PaginatedDTO_CarePartnerResponseDTO_ Successful Response
     * @throws ApiError
     */
    public static listCarePartnersCarePartnersGet({
        page = 1,
        limit = 10,
        firstName,
        lastName,
        email,
        status,
        sort,
        search
    }: {
        /**
         * Page number for pagination, starting at 1
         */
        page?: number
        /**
         * Number of items per page, maximum 1000
         */
        limit?: number
        /**
         * Filter by first name
         */
        firstName?: string | null
        /**
         * Filter by last name
         */
        lastName?: string | null
        /**
         * Filter by email
         */
        email?: string | null
        /**
         * Filter by status. Repeat the param to match any of several, e.g. ?status=active&status=in_contact. Valid values: active, candidate, in_contact, registered, allocated, allocated_group_2, allocated_group_3, record_retrieval, screen_failure, undecided, declined, unreachable, duplicate.
         */
        status?: Array<
            | 'active'
            | 'candidate'
            | 'in_contact'
            | 'registered'
            | 'allocated'
            | 'allocated_group_2'
            | 'allocated_group_3'
            | 'record_retrieval'
            | 'screen_failure'
            | 'undecided'
            | 'declined'
            | 'unreachable'
            | 'duplicate'
        > | null
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
        /**
         * Search across name, email, and phone fields
         */
        search?: string | null
    }): CancelablePromise<PaginatedDTO_CarePartnerResponseDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/care-partners',
            query: {
                page: page,
                limit: limit,
                first_name: firstName,
                last_name: lastName,
                email: email,
                status: status,
                sort: sort,
                search: search
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Create Care Partner
     * Create a new care partner.
     * Supports both authenticated and unauthenticated requests:
     * - If organization_id is provided: public request (no auth required)
     * - If organization_id is not provided: authenticated request (uses current user's organization)
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createCarePartnerCarePartnersPost({
        requestBody
    }: {
        requestBody: CarePartnerCreateDTO
    }): CancelablePromise<CarePartnerResponseDTO | CarePartnerPublicResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/care-partners/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Care Partner
     * Get a care partner by ID.
     * @returns CarePartnerResponseDTO Successful Response
     * @throws ApiError
     */
    public static getCarePartnerCarePartnersCarePartnerIdGet({
        carePartnerId
    }: {
        carePartnerId: string
    }): CancelablePromise<CarePartnerResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/care-partners/{care_partner_id}',
            path: {
                care_partner_id: carePartnerId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Update Care Partner
     * Update a care partner.
     * Automatically logs all field changes to the audit trail.
     * @returns CarePartnerResponseDTO Successful Response
     * @throws ApiError
     */
    public static updateCarePartnerCarePartnersCarePartnerIdPatch({
        carePartnerId,
        requestBody
    }: {
        carePartnerId: string
        requestBody: CarePartnerUpdateDTO
    }): CancelablePromise<CarePartnerResponseDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/care-partners/{care_partner_id}',
            path: {
                care_partner_id: carePartnerId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Care Partner Details
     * Get care partner details including assigned candidates and patients.
     *
     * This endpoint returns all information needed for the care partner details page,
     * including:
     * - List of candidates assigned to this care partner
     * - List of patients assigned to this care partner
     *
     * When a candidate converts to a patient, both relationships may exist,
     * so this endpoint provides a complete view of all assigned subjects.
     * @returns CarePartnerDetailsDTO Successful Response
     * @throws ApiError
     */
    public static getCarePartnerDetailsCarePartnersCarePartnerIdDetailsGet({
        carePartnerId
    }: {
        carePartnerId: string
    }): CancelablePromise<CarePartnerDetailsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/care-partners/{care_partner_id}/details',
            path: {
                care_partner_id: carePartnerId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Care Partner By Candidate
     * Get care partner details associated with a specific candidate.
     * @returns CarePartnerResponseDTO Successful Response
     * @throws ApiError
     */
    public static getCarePartnerByCandidateCarePartnersByCandidateCandidateIdGet({
        candidateId
    }: {
        candidateId: string
    }): CancelablePromise<CarePartnerResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/care-partners/by-candidate/{candidate_id}',
            path: {
                candidate_id: candidateId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get Care Partner By Patient
     * Get care partner details associated with a specific patient.
     * @returns CarePartnerResponseDTO Successful Response
     * @throws ApiError
     */
    public static getCarePartnerByPatientCarePartnersByPatientPatientIdGet({
        patientId
    }: {
        patientId: string
    }): CancelablePromise<CarePartnerResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/care-partners/by-patient/{patient_id}',
            path: {
                patient_id: patientId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Associate Candidate
     * Associate a care partner with a candidate using path parameters.
     * Supports both authenticated and unauthenticated requests:
     * - If authenticated: uses current user's real values (organization_id from user, real user_id)
     * - If not authenticated: requires organization_id query parameter (uses SYSTEM_USER)
     * @returns void
     * @throws ApiError
     */
    public static associateCandidateCarePartnersCarePartnerIdCandidateCandidateIdPost({
        carePartnerId,
        candidateId,
        organizationId
    }: {
        carePartnerId: string
        candidateId: string
        /**
         * Organization ID for RLS context (required for public requests)
         */
        organizationId?: string | null
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/care-partners/{care_partner_id}/candidate/{candidate_id}',
            path: {
                care_partner_id: carePartnerId,
                candidate_id: candidateId
            },
            query: {
                organization_id: organizationId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Associate Patient
     * Associate a care partner with a patient using path parameters.
     * @returns void
     * @throws ApiError
     */
    public static associatePatientCarePartnersCarePartnerIdPatientPatientIdPost({
        carePartnerId,
        patientId
    }: {
        carePartnerId: string
        patientId: string
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/care-partners/{care_partner_id}/patient/{patient_id}',
            path: {
                care_partner_id: carePartnerId,
                patient_id: patientId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Update Care Partner Status
     * Update care partner status to any valid value.
     * Allows changing status at any time - useful for cases like care partner was unreachable but later contacts us.
     * Automatically logs status changes to the audit trail.
     * @returns string Successful Response
     * @throws ApiError
     */
    public static updateCarePartnerStatusCarePartnersCarePartnerIdStatusPatch({
        carePartnerId,
        newStatus
    }: {
        carePartnerId: string
        newStatus:
            | 'active'
            | 'candidate'
            | 'in_contact'
            | 'registered'
            | 'allocated'
            | 'allocated_group_2'
            | 'allocated_group_3'
            | 'record_retrieval'
            | 'screen_failure'
            | 'undecided'
            | 'declined'
            | 'unreachable'
            | 'duplicate'
    }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/care-partners/{care_partner_id}/status',
            path: {
                care_partner_id: carePartnerId
            },
            query: {
                new_status: newStatus
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
